import { Card } from "@/components/ui/card";
import {
  GenieShowcaseSelector,
  GenieShowcaseJumpToStartButton,
  GenieShowcaseJumpToEndButton,
  AgentEmailStatus,
} from "@/components/GenieShowcaseSelector";
import { Agent } from "@/types/agent/agent";

interface AgentSelectorProps {
  agents: Agent[];
  selectedAgentId: string | null;
  onAgentSelect: (agentId: string | null) => void;
  agentEmailStatuses?: Map<string, AgentEmailStatus>;
}

const GENIE_SELECTOR_CONTAINER_ID = "email-templates-genie-selector";

const AgentSelector = ({ agents, selectedAgentId, onAgentSelect, agentEmailStatuses }: AgentSelectorProps) => {
  return (
    <Card className="p-4 sm:p-6 mb-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-1.5">
          <GenieShowcaseJumpToStartButton containerId={GENIE_SELECTOR_CONTAINER_ID} />
          <h3 className="text-sm font-semibold text-gray-700">Genie</h3>
          <GenieShowcaseJumpToEndButton containerId={GENIE_SELECTOR_CONTAINER_ID} />
        </div>
        <button
          onClick={() => onAgentSelect(null)}
          className={`text-sm font-medium transition-colors ${
            selectedAgentId === null
              ? "text-genie-primary"
              : "text-gray-500 hover:text-genie-primary"
          }`}
        >
          All Genies
          {selectedAgentId === null && (
            <span className="ml-1.5 text-xs text-genie-primary">(selected)</span>
          )}
        </button>
      </div>
      <GenieShowcaseSelector
        agents={agents}
        selectedAgentId={selectedAgentId}
        onSelectAgent={onAgentSelect}
        showAllOption={false}
        containerId={GENIE_SELECTOR_CONTAINER_ID}
        agentEmailStatuses={agentEmailStatuses}
        compact
        renderJumpButtonsInline
      />
    </Card>
  );
};

export default AgentSelector;
